import DebugLogger from '../../utils/loggers/debug';
import {
  GiftCardEmailPurchaseMutation,
  GiftCardMailPurchaseMutation,
  GiftCardPrintPurchaseMutation,
} from './GiftCardPurchase';

let logger: DebugLogger | null = null;

export const getGiftCardsLogger = () => {
  if (logger) return logger;

  logger = new DebugLogger('GIFT_CARDS');

  return logger;
};

export const getGiftIdFromPurchaseMutation = (
  data:
    | GiftCardEmailPurchaseMutation
    | GiftCardMailPurchaseMutation
    | GiftCardPrintPurchaseMutation,
): string | null => {
  const keys: (
    | 'giftCardEmailPurchase'
    | 'giftCardMailPurchase'
    | 'giftCardPrintPurchase'
  )[] = [
    'giftCardEmailPurchase',
    'giftCardMailPurchase',
    'giftCardPrintPurchase',
  ];

  for (const key of keys) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payload = (data as any)[key];

    if (
      payload &&
      payload.result &&
      // eslint-disable-next-line no-underscore-dangle
      payload.result.__typename === 'GiftCardPurchaseSuccess'
    ) {
      return payload.result.giftId ?? null;
    }
  }

  return null;
};

export const formatKey = (prefix: string, key: string): string => {
  const camelCase = key
    .toLowerCase()
    .replace(/_([a-z])/g, match => match[1].toUpperCase());

  return prefix
    ? prefix + camelCase.charAt(0).toUpperCase() + camelCase.slice(1)
    : camelCase;
};

export const keyToDisplay = (key: string): string => {
  return key
    .split('_')
    .filter(word => word !== 'MODULE')
    .map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
    .join(' ');
};

export const stateAbbreviations = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
